// extracted by mini-css-extract-plugin
export default {"root":"Checkbox__root--1gMK_","checkbox":"Checkbox__checkbox--FoIbz","blue":"Checkbox__blue--3HIcA","new":"Checkbox__new--3V6WU"};